import * as React from "react";
import { observable, action } from "mobx";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { WorkExperience } from "../../../models/profile";
import { IAddJobLocalization, IResumeLocalization, ILocalization } from "../../../models/localization";
import { JobType, LookupType } from "../../../models/enums";
import { LookupValue } from "../../../models/lookup";
import { ParsedResumeResults } from "../../../models/parsedResumeResults";
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import ResumeNavBtns from "../resumeNavBtns";
import CheckBox from "material-ui/Checkbox";
import { MMYYRangePicker, MMYYPickValue } from "../../widgets/mmyyPicker";
import ReferenceEditor, { RefField } from "../referenceEditor";
import DescriptionEditor from "../descriptionEditor";
import Select from "material-ui/Select"
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormControlLabel } from "material-ui/Form";
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import { InputLabel } from "material-ui/Input";
import * as s from "./militaryExperience.css";

@observer
export default class MilitaryExperienceEditor extends React.Component<{ store: SeekerStore, exp: WorkExperience, fromResume: boolean }, {}> {
  @observable rankValid: boolean;
  @observable mosValid: boolean;
  @observable dutyTypeValid: boolean;
  constructor(props: any) {
    super(props);
    this.rankValid = this.mosValid = this.dutyTypeValid = false;
  }
  @action onChangeMMYY = (val: number, fmt: MMYYPickValue): void => {
    switch (fmt) {
      case MMYYPickValue.FromMon:
        this.props.exp.fromMon = val;
        break;
      case MMYYPickValue.FromYear:
        this.props.exp.fromYear = val;
        break;
      case MMYYPickValue.ToMon:
        this.props.exp.toMon = val;
        break;
      case MMYYPickValue.ToYear:
        this.props.exp.toYear = val;
        break;
      case MMYYPickValue.Current:
        this.props.exp.active = val === 1;
        break;
    }
  }
  @action onChangeReference = (val: string, fmt: RefField): void => {
    switch (fmt) {
      case RefField.Name:
        this.props.exp.refName = val;
        break;
      case RefField.Title:
        this.props.exp.refTitle = val;
        break;
      case RefField.Phone:
        this.props.exp.refPhone = val;
        break;
      case RefField.Contact:
        this.props.exp.refContact = val;
        break;
    }
  }
  @action onChangeDescription = (val: string): void => {
    this.props.exp.desc = val;
  }
  @action onChangeProperty = (e: any): void => {
    const key: string = e.target.id || e.target.name;
    this.props.exp[key] = e.target.value;

    if (key === "rank") {
      if (e.target.value > 0) {
        this.rankValid = true;
        this.handleValidation();
      }
      if (e.target.value === 0) {
        this.rankValid = false;
        this.props.store.profileStore.setDateIsValid(false);
      }
    }
    if (key === "mos") {
      if (e.target.value !== "") {
        this.mosValid = true;
        this.handleValidation();
       }
      if (e.target.value === "") {
        this.mosValid = false;
        this.props.store.profileStore.setDateIsValid(false);
       }
    }
    if (key === "serviceType") {
      if (e.target.value > 0){
        this.dutyTypeValid = true;
        this.handleValidation();
      }
      if (e.target.value === 0) {
        this.dutyTypeValid = false;
        this.props.store.profileStore.setDateIsValid(false);
      }
    }
    
  }
  getMenuItems(type: LookupType, label: string, val: string):JSX.Element[] {
    const menus: JSX.Element[] = [];
    menus.push(<MenuItem key="select" value={0}>{this.props.store.localization.fields.select}</MenuItem>);
    this.props.store.localization.getLookup(type).map((lv: LookupValue, i: number): void => {
      menus.push(<MenuItem key={i} value={lv[val]}>{lv[label]}</MenuItem>);
    });
    return menus;
  }
  getRanks(): JSX.Element[] {
    if (this.props.exp.service && this.props.exp.service > 0) {
      let type: LookupType = LookupType.Unknown;
      switch (this.props.exp.service) {
        case 1:
          type = LookupType.RanksAirForce;
          break;
        case 2:
          type = LookupType.RanksArmy;
          break;
        case 3:
          type = LookupType.RanksCoastGuard;
          break;
        case 4:
          type = LookupType.RanksMarines;
          break;
        case 5:
          type = LookupType.RanksNavy;
          break;
      }
      return (type > 0) ? this.getMenuItems(type, "value", "order") : new Array<JSX.Element>();
    } else {
      return new Array<JSX.Element>();
    }
  }
  handleValidation = (): void => {
    if (this.mosValid && this.dutyTypeValid && this.rankValid) {
      this.props.store.profileStore.setDateIsValid(true);
    }
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const jobLocal: IAddJobLocalization = this.props.store.localization.fields.addJob;
    const resumeLocal: IResumeLocalization = this.props.store.localization.fields.resume;
    const fullWidth: any = { width: "100%" };
    const checked: any = { color: "#5B6770" };
    return (<div>
      {this.props.fromResume && <Row className={s.checkBoxRow}>
        <Col xs={12}>
          <FormControlLabel label={resumeLocal.include} control={<CheckBox style={checked} checked={this.props.store.profileStore.srcIncluded("job")} color="secondary"
            onChange={(e: object, chk: boolean) => this.props.store.profileStore.setSelected("job", chk)} />} />
        </Col>
      </Row>}
        <Row>
        <Col xs={4}>
          <FormControl fullWidth>
          <InputLabel htmlFor="service">{jobLocal.service}</InputLabel>
          <Select value={this.props.exp.service} onChange={this.onChangeProperty} inputProps={{ name: "service", id: "service" }}>
          {this.getMenuItems(LookupType.Services, "value", "order")}
          </Select>
          </FormControl>
          </Col>
        <Col xs={4}>
          <FormControl fullWidth error={!this.dutyTypeValid}>   
            <InputLabel htmlFor="serviceType" style={{ color: "red" }}>{`${jobLocal.dutyType} *${local.required}`}</InputLabel>
            <Select
                name="serviceType"
                value={this.props.exp.serviceType}
                onChange={this.onChangeProperty}
                inputProps={{ name: "serviceType", id: "serviceType" }}>
              {this.getMenuItems(LookupType.ServiceTypes, "value", "order")}
            </Select>
          </FormControl>
          </Col>
        <Col xs={4}>
          <FormControl fullWidth error={!this.rankValid}>
            <InputLabel htmlFor="rank" style={{ color: "red" }}>{`${jobLocal.endRank} *${local.required}`}</InputLabel>
            <Select
                name="rank"
                value={this.props.exp.rank}
                onChange={this.onChangeProperty}
                inputProps={{ name: "rank", id: "rank" }}>
              {this.getRanks()}
              </Select>
          </FormControl>
          </Col>
        </Row>
        <Row>
        <Col xs={12} sm={6} md={6} lg={6} xl={4} className={s.col}>
          <TextField
              error={!this.mosValid}
              name="mos"
              id="mos"
              label={jobLocal.MOS}                 
              value={this.props.exp.mos}
              helperText={local.required}
              onChange={this.onChangeProperty}
              fullWidth />
          </Col>
        <Col xs={12} sm={6} md={6} lg={6} xl={4} className={s.col}>
          <TextField id="position" label={jobLocal.position} value={this.props.exp.position} onChange={this.onChangeProperty} fullWidth />
          </Col>
        </Row> 
        <Row className={s.row}>
        <Col xs={12} sm={12} md={6} lg={6} xl={4}>
          <MMYYRangePicker store={this.props.store} title={jobLocal.servicePeriod} fromLabel={jobLocal.from} toLabel={jobLocal.to} fwd={false}
            currentLabel={jobLocal.currentMil} current={this.props.exp.active} fromMon={this.props.exp.fromMon} fromYr={this.props.exp.fromYear} toMon={this.props.exp.toMon} toYr={this.props.exp.toYear}
            onChange={this.onChangeMMYY} />
        </Col>
        <Col xs={12} sm={12} md={6} lg={6} xl={4}>
          <ReferenceEditor store={this.props.store} reference={this.props.exp} onChange={this.onChangeReference} />
        </Col>
      </Row>
      <Row>
          <Col xs={12}>
              <DescriptionEditor store={this.props.store} descriptor={this.props.exp} />
          </Col>
      </Row>
      {this.props.fromResume && <ResumeNavBtns store={this.props.store} />}
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/militaryExperienceEditor/index.tsx